import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
// Make sure to import renderEventContent if it's used
import { renderEventContent } from './InvestorTracker';

export function CalendarPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const meetingPipeline = location.state?.meetingPipeline || [];
  const demoMeeting = location.state?.demoMeeting || null;
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 via-purple-600 to-purple-800 py-8 flex flex-col">
      <div className="max-w-4xl w-full mx-auto px-2 sm:px-6 lg:px-8">
        <button
          onClick={() => navigate('/investor-tracker')}
          className="mb-4 inline-flex items-center px-4 py-2 rounded-xl bg-white/90 text-blue-700 font-semibold shadow hover:bg-blue-50"
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
          Back
        </button>
        <div className="bg-white/95 backdrop-blur-lg rounded-3xl shadow-2xl p-4 md:p-8 border border-white/20">
          <FullCalendar
            plugins={[dayGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            headerToolbar={{
              left: 'prev,next today',
              center: 'title',
              right: ''
            }}
            height="auto"
            aspectRatio={1.2}
            events={[
              ...(demoMeeting ? [demoMeeting] : []),
              ...meetingPipeline
            ].map(m => ({
              id: m.id,
              title: m.contact + (m.isDemo ? ' (Demo)' : ''),
              start: m.meetingDate,
              extendedProps: m,
              backgroundColor: m.isDemo ? '#a5b4fc' : '#6ee7b7',
              borderColor: m.isDemo ? '#6366f1' : '#10b981',
              textColor: '#22223b',
              classNames: m.isDemo ? 'font-bold' : ''
            }))}
            eventClick={info => {
              info.jsEvent.preventDefault();
              // Optionally, handle event click here
            }}
            dateClick={({ date }) => {
              // Optionally, handle date click here
            }}
            dayMaxEventRows={2}
            eventContent={renderEventContent}
            dayCellClassNames={({ date }) => {
              const today = new Date().toISOString().slice(0, 10);
              const dateStr = date.toISOString().slice(0, 10);
              return dateStr === today ? 'bg-gradient-to-br from-blue-500 to-purple-600 text-white font-bold rounded-lg shadow-lg' : '';
            }}
            contentHeight="auto"
            fixedWeekCount={false}
            displayEventTime={false}
          />
        </div>
      </div>
    </div>
  );
} 